// src/shared/http/token.js
//
// Extracted from the original http-common.js TokenService.
// Single source of truth for JWT token access.

const TOKEN_KEY = 'token';

export const TokenService = {
  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },

  setToken(token) {
    localStorage.setItem(TOKEN_KEY, token);
  },

  removeToken() {
    localStorage.removeItem(TOKEN_KEY);
  },

  /** Quick boolean — does a token string exist in storage? */
  isValid() {
    return !!this.getToken();
  },

  /** Decodes the JWT payload and checks exp > now. */
  hasValidToken() {
    const token = this.getToken();
    if (!token) return false;
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.exp > Date.now() / 1000;
    } catch {
      return false;
    }
  },

  /** Inverse of hasValidToken — safe for guards that need "is expired?" */
  isTokenExpired() {
    const token = this.getToken();
    if (!token) return true;
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.exp <= Date.now() / 1000;
    } catch {
      return true;
    }
  },

  /** Seconds remaining before the current token expires. */
  getTokenRemainingTime() {
    const token = this.getToken();
    if (!token) return 0;
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return Math.max(0, payload.exp - Math.floor(Date.now() / 1000));
    } catch {
      return 0;
    }
  },

  /** Returns a header object ready to spread into fetch/axios config. */
  getAuthHeader() {
    const token = this.getToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
  },
};
